// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"92536cf1","224":"723621c9","250":"2a1dbf09","407":"2712f73f","436":"42539317","453":"f394a27d","455":"2b9dbaca","501":"d909d05e","595":"9b7632a2","606":"d433d16a","691":"6d333355","821":"1cc8d167","925":"d580bf63","969":"bde48b7a"}[chunkId] + ".chunk.js";
};